import { render, staticRenderFns } from "./Acknowledgment.vue?vue&type=template&id=5af9bf85&"
import script from "./Acknowledgment.vue?vue&type=script&lang=ts&"
export * from "./Acknowledgment.vue?vue&type=script&lang=ts&"
import style0 from "./Acknowledgment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports